import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { BuildingSelectFormikField } from '../../Building'
import { DOC_FLOW_FORM_FIELD_BUILDINGS } from '../DocFlow.constants'
import { getDocFlowScopeBuildingApiParams } from '../DocFlow.utils.scope'

import { DOC_FLOW_SCOPE_BUILDINGS_FIELD_QA_NAME } from './DocFlowScopeBuildingsField.constants'

function DocFlowScopeBuildingsField({
  controlProps,
  fieldComponentProps,
  label,
  name = DOC_FLOW_FORM_FIELD_BUILDINGS,
  ...restProps
}) {
  const { t } = useTranslation()

  const { values } = useFormikContext()

  return (
    <BuildingSelectFormikField
      {...restProps}
      apiParams={getDocFlowScopeBuildingApiParams(values)}
      controlProps={{
        ...controlProps,
        contentProps: {
          inputProps: {
            placeholder: t('DocFlow.FormBuildingsFieldPlaceholderKey'),
          },
        },
      }}
      emptyValue={null}
      fieldComponentProps={{
        ...fieldComponentProps,
        info: t('DocFlow.FormBuildingsFieldInfoKey'),
        label: label ?? t('DocFlow.FormBuildingsFieldLabelKey'),
      }}
      name={name}
      qaName={DOC_FLOW_SCOPE_BUILDINGS_FIELD_QA_NAME}
    />
  )
}

export default DocFlowScopeBuildingsField
